import { cn } from '@/lib/utils/cn';

/**
 * The purple "embrace" figure from the Care For Him logo — used as a recurring
 * brand accent on section dividers and empty states. Decorative (aria-hidden).
 */
export function FigureMotif({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 120 100"
      className={cn('text-purple-500', className)}
      fill="currentColor"
      aria-hidden
    >
      {/* Supporting arms / embrace */}
      <path d="M60 34c-14-18-40-16-50 2-6 11-2 26 12 40 12 12 26 20 38 24 12-4 26-12 38-24 14-14 18-29 12-40-10-18-36-20-50-2z" opacity="0.18" />
      {/* Central figure: head + body */}
      <circle cx="60" cy="30" r="12" />
      <path d="M60 44c-9 0-16 7-16 16v6c0 4 3 7 7 7h18c4 0 7-3 7-7v-6c0-9-7-16-16-16z" />
    </svg>
  );
}
